import { render } from "./EventCountdownLabel.vue?vue&type=template&id=04153f55&scoped=true"
import script from "./EventCountdownLabel.vue?vue&type=script&lang=js"
export * from "./EventCountdownLabel.vue?vue&type=script&lang=js"

import "./EventCountdownLabel.vue?vue&type=style&index=0&id=04153f55&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04153f55"]])

export default __exports__